module.exports = __webpack_public_path__ + "img/underion.40579caa.jpg";